import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Content from '@/src/cms/components/CMSPage/Content';
import Container from '@/src/shared/components/Container';

import CommitteesNav from './CommitteesNav';

const CommitteesPage = memo(function CommitteesPage(props) {
  const { alias, router } = props;
  return (
    <Content
      alias={alias}
      // bodyStyle: PropTypes.any,
      // mutateBody: PropTypes.func,
      renderBeforeContent={() => (
        <div style={{ marginBottom: '32px' }}>
          <Container>
            <CommitteesNav router={router} />
          </Container>
        </div>
      )}
    />
  );
});

CommitteesPage.propTypes = {
  alias: PropTypes.string.isRequired,
};

export default CommitteesPage;
